/**
 * Klasy tabel Centrum uprawnień — ten sam wygląd co wspólna tabela list (`ConfigurableTable`),
 * żeby tabele uprawnień nie wyglądały na „obcięte" obok list kartotek (decyzja właścicielki
 * 2026-09-23):
 *  - karta: zaokrąglona ramka + wewnętrzny odstęp jak karta `ConfigurableTable`, ale BEZ jej
 *    miękkiego cienia — tu tabela stoi wewnątrz innej karty i cień dawał szarą plamę wokół,
 *  - nagłówek: jeden szary pasek z zaokrąglonymi rogami skrajnych komórek (14px) i BEZ kresek
 *    pod tytułami kolumn i pod wierszem wyszukiwarek (typografię nagłówka daje skórka
 *    `table[data-skin='antd']` w index.css).
 * Tabela potrzebuje `border-separate` — przy `border-collapse: collapse` przeglądarka ignoruje
 * zaokrąglenie komórek.
 */
export const PERMISSION_TABLE_CARD_CLASS =
  'overflow-x-auto rounded-3xl border border-[rgba(103,103,103,0.3)] bg-white px-7 pb-3 pt-4 dark:border-gray-700 dark:bg-gray-800';

export const PERMISSION_TABLE_CLASS = 'w-full border-separate border-spacing-0 text-sm';

export const PERMISSION_THEAD_CLASS =
  'bg-bg-tertiary dark:bg-gray-900 [&>tr:first-child>th:first-child]:rounded-tl-[14px] [&>tr:first-child>th:last-child]:rounded-tr-[14px] [&>tr:last-child>th:first-child]:rounded-bl-[14px] [&>tr:last-child>th:last-child]:rounded-br-[14px]';
